import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  previousPath: null,
};

const previousNavigationSlice = createSlice({
  name: 'previousNavigation',
  initialState,
  reducers: {
    setPreviousPath: (state, action) => {
      state.previousPath = action.payload;
    },
    resetPreviousPath: (state) => {
      state.previousPath = null;
    },
  },
});

export const { setPreviousPath, resetPreviousPath } = previousNavigationSlice.actions;

export default previousNavigationSlice.reducer;
